export abstract class ComponentCanDeactivate {
  abstract canDeactivate(): boolean;
}
